import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './pages/Home.vue'
import DefaultLayout from './layouts/Default.vue'
import EmptyLayout from './layouts/Empty.vue'
import Login from './pages/Login.vue'
import Logout from './pages/Logout.vue'
import NoAccess from './pages/NoAccess.vue'

Vue.use(VueRouter)
//component: () => import(/* webpackChunkName: "about" */ //'../views/About.vue')
const routes = [
    {
        path: '/',
        component: DefaultLayout,
        children: [
            {
                path: '/',
                name: 'Home',
                component: Home
            },
            {
                path: '/teams',
                name: "Teams",
                component: () => import('@/pages/Teams.vue')
            },
            {
                path: '/users',
                name: "Users",
                component: () => import('@/pages/Users.vue')
            },
            {
                path: '/manager',
                name: "Manager",
                component: () => import('@/pages/Manager.vue')
            },
            {
                path: '/invoice',
                name: "Invoice",
                component: () => import('@/pages/Invoice.vue')
            },
            {
                path: '/simpleinvoice',
                name: "Simple Invoice",
                component: () => import('@/pages/SimpleInvoice.vue')
            }
        ]
    },
    {
        path: '/',
        component: EmptyLayout,
        children: [
            {
                path: '/login',
                name: 'Login',
                component: Login
            },
            {
                path: '/logout',
                name: 'Logout',
                component: Logout
            },
            {
                path: '*',
                name: 'NoAccess',
                component: NoAccess
            }
        ]
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    //console.log("Guarding.. apiKey: " + localStorage.getItem('apiKey') + ", to: " + to.path + ", from: " + from.path)
    if (localStorage.getItem('apiKey') != null || to.path == '/login' || to.path == '/logout') next()
    else{
        if (from.path == '/login') next(false)
        else if (to.path != '/login') next('/login?redir='+to.path)
        else next()
    }
    
})

export default router